import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgX2 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "icon_circle",
		children: /* @__PURE__ */ _jsx("circle", {
			cx: 16,
			cy: 16,
			r: 16
		})
	}), /* @__PURE__ */ _jsxs("g", {
		fill: "currentColor",
		children: [/* @__PURE__ */ _jsx("path", { d: "M8.5,16.7l-3.4-5h3.1l1.9,3l1.9-3h3l-3.4,5l3.6,5.2H12L10,18.7l-2.1,3.2h-3L8.5,16.7z" }), /* @__PURE__ */ _jsx("path", { d: "M16.5,19.6l4.4-3.6c1.7-1.4,2.3-2.1,2.3-3.2c0-1.1-0.7-1.7-1.8-1.7c-1,0-1.7,0.6-2.7,1.8l-2.1-1.7c1.3-1.8,2.6-2.8,5-2.8 c2.8,0,4.6,1.6,4.6,4.1v0c0,2.2-1.1,3.3-3.5,5.1l-2.2,1.7h5.8v2.5h-9.8V19.6z" })]
	})]
});
export default SvgX2;
